// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './Loading.scss';
import spinkitWave from '../../../node_modules/spinkit/scss/spinners/3-wave.scss';
import spinkitBounces from '../../../node_modules/spinkit/scss/spinners/7-three-bounce.scss';
import loadingCircle from '../../assets/img/loading_circle.gif';
import progressBarStyle from '../../assets/styles/progress-bar.scss';

type Color = 'orange' | 'lightBlue' | 'white';
type Type = 'sk-wave' | 'sk-three-bounce' | 'circle' | 'progress-bar';

type Props = {
  color?: Color;
  type?: Type;
  number?: number;
  className?: string;
};

const spinkitResourceMap: { [key: string]: { [key: string]: string } } = Object.freeze({
  'sk-wave': spinkitWave,
  'sk-three-bounce': spinkitBounces,
});

const waveItem = (n: number, color: Color, spinkit: { [key: string]: string }) =>
  (<div key={n}
        className={classNames(spinkit['sk-rect'], spinkit[`sk-rect${n}`], style[color])}/>);

const bouncesItem = (n: number, color: Color, spinkit: { [key: string]: string }) =>
  (<div key={n}
        className={classNames(spinkit['sk-child'], spinkit[`sk-bounce${n}`], style[color])}/>);

const Loading = (props: Props) => {
  const { className } = props;
  const color = props.color || 'lightBlue';

  if (props.type === 'circle') {
    return <img className={classNames(style.loadingCircle, className)}
                src={loadingCircle}
                alt="loading_circle"/>
  }
  if (props.type === 'progress-bar') {
    return <div className={classNames(progressBarStyle.progressBar, {
      [progressBarStyle.lightBlue]: color === 'lightBlue',
      [progressBarStyle.orange]: color === 'orange',
    }, className)}>
      <div className={progressBarStyle.indeterminate}/>
    </div>
  }

  const type = props.type || 'sk-wave';
  const number = props.number || 5;
  const spinkit = spinkitResourceMap[type];
  return (
    <div className={classNames(spinkit[type], style.loadingWrap, className)}>{
      Array.from({ length: number }, (_: any, i: number) => i).map(n =>
        type === 'sk-wave' ? waveItem(n + 1, color, spinkit) : bouncesItem(n + 1, color, spinkit))
    }</div>
  );
};


Loading.propTypes = {
  color: PropTypes.string,
  type: PropTypes.string,
  number: PropTypes.number,
  className: PropTypes.string,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/elements/Loading/Loading.jsx